// extracted by mini-css-extract-plugin
export default {"terms_main_wrap":"terms_terms_main_wrap__ppaJV","terms_heading":"terms_terms_heading__3tep+","terms_subheading":"terms_terms_subheading__0fYSk","content":"terms_content__YRbk+"};